const fields = [
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: true,
    width: 30,
  },
  {
    key: 'totalDistance',
    label: 'report.fields.totalDistance',
    header: 'total_distance',
    filter: false,
    width: 20,
  },
  {
    key: 'totalTimeTrip',
    label: 'report.fields.totalTimeTrip',
    header: 'total_time_trip',
    filter: false,
    width: 20,
  },
  {
    key: 'totalTimeTripStop',
    label: 'report.fields.totalTimeTripStop',
    header: 'total_time_trip_stop',
    filter: false,
    width: 20,
  },
]
export default fields
